import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import api from "@/lib/api";

const SKIP_PREFIXES = ["/auth", "/dashboard", "/berichten", "/moderatie", "/advertenties", "/omzet", "/bezoekers", "/plaats", "/mijn-biedingen", "/favorieten", "/payment", "/wachtwoord-herstellen"];

function getVisitorId() {
  let vid = localStorage.getItem("fs_vid");
  if (!vid) {
    vid = (crypto.randomUUID && crypto.randomUUID()) || String(Date.now()) + Math.random().toString(36).slice(2);
    localStorage.setItem("fs_vid", vid);
  }
  return vid;
}

export default function PageTracker() {
  const location = useLocation();
  useEffect(() => {
    const path = location.pathname;
    if (SKIP_PREFIXES.some((p) => path.startsWith(p))) return;
    const normalised = path.startsWith("/product/") ? "/product/:id" : path;
    api.post("/track", { path: normalised, visitor_id: getVisitorId() }).catch(() => {});
  }, [location.pathname]);

  useEffect(() => {
    const ping = () => api.post("/ping", { visitor_id: getVisitorId() }).catch(() => {});
    ping();
    const iv = setInterval(ping, 45000);
    return () => clearInterval(iv);
  }, []);

  return null;
}
